import UpdateProgram from "pages/dashboard/shared/UpdateProgram/UpdateProgram";
import { FC } from "react";

interface SchoolProgramUpdateProps {}

const SchoolProgramUpdate: FC<SchoolProgramUpdateProps> = () => {
  return <UpdateProgram />;
};
export default SchoolProgramUpdate;
